import { useEffect, useState } from 'react';
import { loadModule } from '@/services/cms-service';

/**
 * Hook to preload all CMS modules at app startup.
 * This ensures the modulesCache is populated before LinearNoteGenerator
 * attempts to use getModuleConfigSync().
 */

const MODULE_IDS = [
  'signes-vitaux',
  'douleur',
  'etat-general',
  'mobilite',
  'nutrition',
  'elimination-urinaire',
  'elimination-intestinale',
  'cognitif-psychologique',
  'cardiovasculaire',
  'cardio-respiratoire',
  'fonctions-base',
  'evaluation-plaie',
  'soins-plaie-simple',
  'soins-palliatifs',
  'sonde-urinaire',
  'nephrostomie',
  'poc',
  'stomie',
  'catheterisme-vesical',
];

export function useCmsModulesPreload() {
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    async function preloadModules() {
      try {
        await Promise.all(MODULE_IDS.map((id) => loadModule(id)));
        setIsLoading(false);
      } catch (e) {
        setError(e as Error);
        setIsLoading(false);
      }
    }
    preloadModules();
  }, []);

  return { isLoading, error };
}
